export default {"src":"/_next/static/media/node.0e76fa85.svg","height":289,"width":256,"blurWidth":0,"blurHeight":0};